import React from "react";
import { Microscope, TrendingUp, TrendingDown, Minus } from "lucide-react";
import MainTable from "../../../../../components/mainTable";
import { TableColumnsItem } from "../../../../../interfaces/components/mainTable";

interface LabResult {
  id: string;
  testName: string;
  date: string;
  value: string;
  unit: string;
  referenceRange: string;
  status: "normal" | "high" | "low";
}

const mockLabResults: LabResult[] = [
  {
    id: "1",
    testName: "Complete Blood Count (CBC)",
    date: "2024-03-15",
    value: "14.5",
    unit: "g/dL",
    referenceRange: "13.5-17.5",
    status: "normal",
  },
  {
    id: "2",
    testName: "Hemoglobin A1C",
    date: "2024-03-15",
    value: "7.2",
    unit: "%",
    referenceRange: "4.0-5.6",
    status: "high",
  },
  {
    id: "3",
    testName: "Cholesterol",
    date: "2024-03-15",
    value: "180",
    unit: "mg/dL",
    referenceRange: "125-200",
    status: "normal",
  },
  {
    id: "4",
    testName: "Vitamin D",
    date: "2024-03-15",
    value: "18",
    unit: "ng/mL",
    referenceRange: "30-100",
    status: "low",
  },
];

export const LabResultsTab: React.FC = () => {
  const getStatusIcon = (status: string) => {
    switch (status) {
      case "high":
        return <TrendingUp className="w-5 h-5 text-red-500" />;
      case "low":
        return <TrendingDown className="w-5 h-5 text-yellow-500" />;
      default:
        return <Minus className="w-5 h-5 text-green-500" />;
    }
  };

  const columns: TableColumnsItem[] = [
    {
      key: "testName",
      name: "Test Name",
      type: "text",
    },
    {
      key: "date",
      name: "Date",
      type: "text",
    },
    {
      key: "result",
      name: "Result",
      type: "custom",
      customValue: (row) => `${row.value} ${row.unit}`,
    },
    {
      key: "referenceRange",
      name: "Reference Range",
      type: "text",
    },
    {
      key: "status",
      name: "Status",
      type: "custom",
      customValue: (row) => (
        <div className="flex items-center space-x-2">
          {getStatusIcon(row.status)}
          <span
            className={`text-sm font-medium ${
              row.status === "high"
                ? "text-red-600"
                : row.status === "low"
                  ? "text-yellow-600"
                  : "text-green-600"
            }`}
          >
            {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
          </span>
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium dark:text-white">
          Laboratory Results
        </h2>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-primary hover:bg-primary/90">
          <Microscope className="w-4 h-4 mr-2" />
          Add Result
        </button>
      </div>

      <MainTable
        data={mockLabResults}
        columns={columns}
        showSearch={true}
        showAddButton={false}
      />
    </div>
  );
};
